import {
    DEALERAGENTDOWNLOADSAMPLEFILE_FAILED,
    DEALERAGENTDOWNLOADSAMPLEFILE_SUCCESS,
    RESET_DEALERAGENTDOWNLOADSAMPLEFILE,
    LOADING_DEALERAGENTDOWNLOADSAMPLEFILE,
    NETWORK_ERROR_DEALERAGENTDOWNLOADSAMPLEFILE
} from '../types/index'

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERAGENTDOWNLOADSAMPLEFILE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERAGENTDOWNLOADSAMPLEFILE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERAGENTDOWNLOADSAMPLEFILE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERAGENTDOWNLOADSAMPLEFILE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERAGENTDOWNLOADSAMPLEFILE:
            return (state = initialState);
        default:
            return state;
    }
};